"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var BugStatusView = function BugStatusView(_ref) {
  var bugStatus = _ref.bugStatus;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('topic__content-type-pill', 'pill', 'pill--uppercase', 'pill--bug', 'qa-content-type-pill'),
    style: {
      backgroundColor: bugStatus.backgroundColor,
      color: bugStatus.textColor
    }
  }, bugStatus.name);
};

var _default = BugStatusView;
exports.default = _default;